module.exports = __webpack_public_path__ + "img/sort-arrow-desc.929155fa.svg";